import { Menu } from "antd";

const VerticleMenuContent = ({ activeItem, items, itemContainer, onItemClick }) => {
    return (
        <div className="flex size-full flex-1 gap-4 overflow-hidden">
            <div className="scroll-webkit relative flex h-full min-w-[250px] flex-none flex-col overflow-auto border-r border-r-gray-100">
                <Menu
                    style={{ border: 0 }}
                    onSelect={({ key }) => onItemClick(key)}
                    mode="vertical"
                    selectedKeys={[activeItem]}
                    items={items.map((item) => ({
                        key: item.name,
                        label: item.description,
                        "data-testid": `vertical-menu-configuration-${item.name}`,
                    }))}
                />
            </div>
            <div className="scroll-webkit relative flex flex-1 flex-col justify-stretch overflow-hidden">{itemContainer}</div>
        </div>
    );
};

export default VerticleMenuContent;
